import React from "react";
import { Route, Routes } from "react-router-dom";
import AuthLayout from "./containers/AuthLayout";
import Login from "./containers/Login";
import OneTimePassword from "./containers/OneTimePassword";
import ForgotPassword from "./containers/ForgotPassword";
import ResetPassword from "./containers/ResetPassword";
import { FORGOT_PASSWORD, RESET_PASSWORD, ONE_TIME_PASSWORD, CONFIRMATION, PERMISSION } from "constants/path";
import Confirmation from "./containers/Confirmation";
import Permission from "./containers/Permission";

function Auth() {
	return (
		<Routes>
			<Route element={<AuthLayout />}>
				<Route exact path="/" element={<Login />} />
				<Route exact path={ONE_TIME_PASSWORD} element={<OneTimePassword />} />
				<Route exact path={FORGOT_PASSWORD} element={<ForgotPassword />} />
				<Route exact path={RESET_PASSWORD} element={<ResetPassword />} />
				<Route exact path={CONFIRMATION} element={<Confirmation />} />
				<Route exact path={PERMISSION} element={<Permission />} />
			</Route>
		</Routes>
	)
}

export default Auth;
